import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import Audit from '@/store/modules/Audit';
import Mailbox from '@/store/modules/Mailbox';
import Lodging from '@/store/modules/Lodging';
import Maintenance from '@/store/modules/Maintenance';
import MaterialsAndSupplies from '@/store/modules/MaterialsAndSupplies';
import Payments from '@/store/modules/Payments';
import Person from '@/store/modules/Person';
import Place from '@/store/modules/Place';
import Snackbar from '@/store/modules/Snackbar';
import User from '@/store/modules/User';
// import Calendar from '@/store/modules/Calendar';

Vue.use(Vuex);

const dataPerssist = createPersistedState({
	paths: ['User'],
});

export default new Vuex.Store({
	modules: {
		Audit,
		Mailbox,
		Lodging,
		Maintenance,
		MaterialsAndSupplies,
		Payments,
		Person,
		Place,
		Snackbar,
		User,
		// Calendar,
	},
	plugins: [dataPerssist],
});
